export enum ImageUploadModal {
    LoadingModal = 'LoadingModal',
    RemovalModal = 'RemovalModal',
    ResizeModal = 'ResizeModal',
    UploadSuccessModal = 'UploadSuccessModal',
    RemoveSuccessModal = 'RemoveSuccessModal',
    ErrorModal = 'ErrorModal',
    None = 'None',
}
